// material-ui
import { withStyles } from "@material-ui/core/styles";
// components
import App from "components/App";
import Centrifugo from "components/Centrifugo";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
// styles
import styles from "./styles";

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

class Root extends Component {
  static propTypes = {
    getStudioSessionMercury: PropTypes.func,
  };

  render() {
    return (
      <Centrifugo>
        <App />
      </Centrifugo>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Root));
